export const CATEGORIES = [
  { key: "prayer-mats", label: "Prayer Mats", ar: "سجادة" },
  { key: "quran", label: "Holy Quran", ar: "القرآن" },
  { key: "attar", label: "Attar & Oud", ar: "عطر" },
  { key: "tasbih", label: "Tasbih", ar: "تسبيح" },
  { key: "ihram", label: "Ihram", ar: "إحرام" },
  { key: "travel", label: "Umrah Travel Kit", ar: "سفر" },
  { key: "dates", label: "Ajwa & Dry Fruits", ar: "تمر" },
  { key: "mens", label: "Men's Wear", ar: "رجال" },
  { key: "hijab", label: "Hijab & Abaya", ar: "حجاب" },
  { key: "books", label: "Islamic Books", ar: "كتب" },
  { key: "kids", label: "Kids & Learning", ar: "أطفال" },
  { key: "gadgets", label: "Azan Clocks & Gadgets", ar: "أجهزة" },
  { key: "wellness", label: "Health & Sunnah Care", ar: "صحة" },
  { key: "gifts", label: "Gifts & Hampers", ar: "هدايا" },
  { key: "kitchen", label: "Kitchen & Dining", ar: "مطبخ" },
  { key: "decor", label: "Home & Decor", ar: "زينة" },
];

export const catLabel = (k) => CATEGORIES.find((c) => c.key === k)?.label || "Collection";

export const offPct = (p) => (Number(p.mrp) > Number(p.price) && Number(p.price) > 0 ? Math.round(((p.mrp - p.price) / p.mrp) * 100) : 0);
